import { ReactElement, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props: any) => {
    const location = useLocation();

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }, [location]);

    return (<>{props.children}</>);
};

export default ScrollToTop;